import { Injectable } from '@angular/core';
import { getDownloadURL, ref, Storage } from '@angular/fire/storage';
import { CdnResourcesSignerService } from './cdn-resources-signer.service';
import { FLAGS, FlagsService } from './flags.service';

@Injectable({
  providedIn: 'root',
})
export class ThumbnailService {
  constructor(
    private storage: Storage,
    private flagsService: FlagsService,
    private cdnResourcesSignerService: CdnResourcesSignerService,
  ) {}

  async getThumbnailUrl(
    filename: string,
    imgDownloadURL: string,
    width: number,
    height: number,
  ): Promise<any> {
    const thumbnailPath = `${
      filename ?? this.getLastSegmentUrl(imgDownloadURL)
    }_${width}x${height}`;
    const thumbnailsRef = ref(this.storage, `thumbnails/${thumbnailPath}`);

    return this.resolveDownloadUrl(thumbnailsRef);
  }

  private async resolveDownloadUrl(thumbnailsRef: ReturnType<typeof ref>): Promise<string> {
    if (!this.flagsService.isFlagEnabled(FLAGS.ENABLE_CDN_RESOURCES_SIGNING)) {
      return getDownloadURL(thumbnailsRef);
    }

    try {
      return await this.cdnResourcesSignerService.getSignedUrl(thumbnailsRef.fullPath);
    } catch (error) {
      return getDownloadURL(thumbnailsRef);
    }
  }

  private getLastSegmentUrl(url: string): string {
    const withoutQueries = url.split('?')[0];
    const segments = withoutQueries.split('/');
    return segments[segments.length - 1];
  }
}
